module.exports = __webpack_public_path__ + "components/country-flag/static/bt-018ed8d2398290f99754c18caa498cd4.svg";